// extracted by mini-css-extract-plugin
module.exports = {"d0":"Telephone_d0__2n-Fl"};